module.exports = __webpack_public_path__ + "assets/img/img302.b9f9d2da.png";